// extracted by mini-css-extract-plugin
export default {"outlined__button":"styles_outlined__button__msdU3","app__button":"styles_app__button__90CKy"};